import { render, staticRenderFns } from "./notePhone.vue?vue&type=template&id=8b29ee46&scoped=true"
import script from "./notePhone.vue?vue&type=script&lang=js"
export * from "./notePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b29ee46",
  null
  
)

export default component.exports